/**
 * @generated SignedSource<<dadf59856297606814afe672008e4d2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetNewsfeedInput = {
  newsfeedId: string;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAIntegrationNewsfeedMutation$variables = {
  input: CreateWidgetNewsfeedInput;
  storecastId: string;
};
export type WAIntegrationNewsfeedMutation$data = {
  readonly dashboard: {
    readonly createWidgetNewsfeed: {
      readonly id: string;
    };
  };
};
export type WAIntegrationNewsfeedMutation = {
  response: WAIntegrationNewsfeedMutation$data;
  variables: WAIntegrationNewsfeedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetNewsfeed",
        "kind": "LinkedField",
        "name": "createWidgetNewsfeed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationNewsfeedMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationNewsfeedMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ea398bff9f8d0bead6463b4a29c5d610",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationNewsfeedMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationNewsfeedMutation(\n  $storecastId: ID!\n  $input: CreateWidgetNewsfeedInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetNewsfeed(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1f4408c3b88e97fe7bbf99741798372";

export default node;
